import clsx from 'clsx'
import { FieldRenderProps } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { TextField, Typography, InputAdornment } from '@mui/material'
import DeleteIcon from '@mui/icons-material/ClearRounded'

type TextboxProps = FieldRenderProps<any, HTMLElement> & {
    label: string
    textAfterLabel?: string
    maxLength?: number
    disabled?: boolean
    fullWidth?: boolean
    startAdornment?: JSX.Element
    endAdornment?: JSX.Element
    autoComplete?: string
}

export const ViewTextboxProps = () => (
    <pre className="prettyprint lang-js" style={{ backgroundColor: '#e6e6e6' }}>
        {`type TextboxProps = {
    label: string
    maxLength?: number
    disabled?: boolean
    fullWidth?: boolean
}`}
    </pre>
)

const useStyles = makeStyles((theme: Theme) => ({
    label: {
        '& .MuiFormLabel-root': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '-webkit-fill-available',
        },
        '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
        },
        '& input::-ms-reveal, input::-ms-clear': {
            display: 'none',
        },
    },
    disabledField: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: theme.palette.getContrastText('bg-backoffice'),
        },
    },
}))

const TextboxControl = (props: TextboxProps) => {
    const { t } = useTranslation()
    const classes = useStyles()
    const isError: boolean = props.meta.error && props.meta.touched
    const helperText: string = props.meta.error

    return (
        <>
            <Typography>
                {props.label} {!props.disabled && props.required && <label style={{ color: '#d32f2f' }}>{' *'}</label>}{' '}
                {props.textAfterLabel && props.textAfterLabel}
            </Typography>
            <TextField
                variant="outlined"
                className={clsx(classes.label, { [classes.disabledField]: props.disabled })}
                value={props.input.value}
                placeholder={props.placeholder}
                onBlur={props.input.onBlur}
                onChange={props.input.onChange}
                error={isError}
                helperText={isError ? (helperText === 'Required' ? t('LABEL.TEXT_REQUIRED') : helperText) : ''}
                disabled={props.disabled}
                inputProps={{
                    maxLength: props.maxLength,
                    autoComplete: props.inputProps?.autoComplete ?? 'off',
                }}
                InputProps={{
                    startAdornment: props.startAdornment && (
                        <InputAdornment position="start">{props.startAdornment}</InputAdornment>
                    ),
                    endAdornment: props.endAdornment && (
                        <InputAdornment position="end">{props.endAdornment}</InputAdornment>
                    ),
                }}
                size="small"
                fullWidth={props.fullWidth}
                type={props.input.type}
                onKeyUp={props.onKeyUp}
            />
        </>
    )
}

export default TextboxControl
